<div class="modal-header" cdkDrag cdkDragRootElement=".modal-content" cdkDragHandle>
  <h5 class="modal-title">Enquiries Checklist</h5>
  <div class="d-flex gap-2 align-items-center  ms-auto">
    <button type="button" 
            class="btn btn-outline-secondary btn-sm" 
            (click)="openAuditForForm()">
      <fa-icon [icon]="faHistory"></fa-icon>
    </button>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
  </div>
</div>

<div class="modal-body">
  
  <div *ngIf="!loaded" class="text-center py-3">
    <div class="spinner-border text-success" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>

  <div *ngIf="loaded">
    <div class="d-flex justify-content-end mb-3">
      <button type="button" 
              class="btn btn-success" 
              (click)="addEnquiry()">
        <fa-icon [icon]="faPlus" class="me-1"></fa-icon>
        Add Enquiry
      </button>
    </div>

    <div *ngIf="items.length === 0" class="alert alert-info">
      No enquiries
    </div>

    <div *ngIf="items.length > 0" class="table-responsive" style="max-height: 60vh; overflow-y: auto;">
      <table mat-table [dataSource]="items">

        <ng-container matColumnDef="enquiry">
          <th mat-header-cell *matHeaderCellDef>Enquiry</th>
          <td mat-cell *matCellDef="let element">
            <span (click)="editEnquiry(element.id, element.enquiry)" 
                  style="cursor: pointer;">
              {{element.enquiry}}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="receivedDate">
          <th mat-header-cell *matHeaderCellDef style="width: 150px">Received</th>
          <td mat-cell *matCellDef="let element">
            <div class="d-flex align-items-center justify-content-between">
              <span>
                {{element.receivedDate | date: 'dd/MM/yyyy'}}
                <small *ngIf="element.receivedDate==null" class="fst-italic text-muted">add date...</small>
              </span>
              <button type="button" 
                      class="btn btn-link btn-sm p-0 ms-2" 
                      (click)="showDatePicker(element.id, 'receivedDate', element.receivedDate)">
                <fa-icon [icon]="faPencil" class="text-success"></fa-icon>
              </button>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="repliedDate">
          <th mat-header-cell *matHeaderCellDef style="width: 150px">Replied</th>
          <td mat-cell *matCellDef="let element">
            <div class="d-flex align-items-center justify-content-between">
              <span>
                {{element.repliedDate | date: 'dd/MM/yyyy'}}
                <small *ngIf="element.repliedDate==null" class="fst-italic text-muted">add date...</small>
              </span>
              <button type="button" 
                      class="btn btn-link btn-sm p-0 ms-2" 
                      (click)="showDatePicker(element.id, 'repliedDate', element.repliedDate)">
                <fa-icon [icon]="faPencil" [class]="element.repliedDate==null ? 'text-warning' : 'text-success'"></fa-icon>
              </button>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="satisfiedDate">
          <th mat-header-cell *matHeaderCellDef style="width: 150px">Satisfied</th>
          <td mat-cell *matCellDef="let element">
            <div class="d-flex align-items-center justify-content-between">
              <span>
                {{element.satisfiedDate | date: 'dd/MM/yyyy'}}
                <small *ngIf="element.satisfiedDate==null" class="fst-italic text-muted">add date...</small>
              </span>
              <button type="button" 
                      class="btn btn-link btn-sm p-0 ms-2" 
                      (click)="showDatePicker(element.id, 'satisfiedDate', element.satisfiedDate)">
                <fa-icon [icon]="faPencil" [class]="element.satisfiedDate==null ? 'text-warning' : 'text-success'"></fa-icon>
              </button>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef style="width: 50px"></th>
          <td mat-cell *matCellDef="let element" class="text-end">
            <button type="button" 
                    class="btn btn-link btn-sm p-0 text-danger" 
                    (click)="archiveEnquiry(element.id)" 
                    *ngIf="!element.isCompleted">
              <fa-icon [icon]="faTimes"></fa-icon>
            </button>
            <fa-icon [icon]="faCheck" 
                     class="text-success" 
                     *ngIf="element.isCompleted"></fa-icon>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>

  </div>

</div>